<template>
  <i :class="[getIconType, getIconName, theme, color, size]"></i>
</template>
<script>
export default {
  name: 'faIcon',
  props: ['iconType', 'iconName', 'iconSize', 'color', 'noTheme', 'iconOfTitle'],
  computed: {
    theme() {
      if (!this.noTheme) {
        return window.config.theme;
      } else {
        return null;
      }
    },
    getIconType() {
      if (this.iconType) {
        return this.iconType;
      } else {
        return 'fa-light';
      }
    },
    getIconName() {
      return this.iconName;
    },
    size() {
      return this.iconSize || (this.iconOfTitle ? 'fa-2x' : '');
    },
  },
};
</script>
<style lang="scss">
.arancione_advenias {
  color: #00aab1;
}
.blu_sky {
  color: #008cd6;
}
.green_bean {
  color: #00a600;
}
.red_dexter {
  color: #d00;
}
.marrone_chocolate {
  color: #8b8885;
}
</style>
